import { render, staticRenderFns } from "./DefautChamp.vue?vue&type=template&id=b48e8138&scoped=true"
import script from "./DefautChamp.vue?vue&type=script&lang=js"
export * from "./DefautChamp.vue?vue&type=script&lang=js"
import style0 from "./DefautChamp.vue?vue&type=style&index=0&id=b48e8138&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e8138",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b48e8138')) {
      api.createRecord('b48e8138', component.options)
    } else {
      api.reload('b48e8138', component.options)
    }
    module.hot.accept("./DefautChamp.vue?vue&type=template&id=b48e8138&scoped=true", function () {
      api.rerender('b48e8138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefautChamp.vue"
export default component.exports